export default "__VITE_ASSET__BrIIAFQ1__"